import { useEffect, useState } from "react";
import { ShieldCheck } from "lucide-react";
import { api } from "@/lib/api";
import { useLiveRefresh } from "@/lib/live";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import QcMaterials from "@/components/stores/QcMaterials";

const n = (v) => Number(v || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 });

/** Count tile (same shape as every dashboard's "Partially dispatched") for rolls waiting on incoming
 * QC — click it to open the full actionable list (approve/reject) in a dialog; nothing shows until
 * then, same as every other desk's tiles. */
export default function MaterialsQcTile() {
  const [total, setTotal] = useState(null);
  const [open, setOpen] = useState(false);
  const load = () => api.get("/stores/rolls", { params: { qc_status: "PENDING", available: true, limit: 1 } })
    .then(({ data }) => setTotal(data.total)).catch(() => setTotal((t) => t ?? 0));
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useLiveRefresh("stores", load);

  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="kpi-materials-qc"
        className="block h-full w-full text-left border border-neutral-200 bg-white px-3 py-2.5 md:px-4 md:py-3 hover:border-[#FF5A00] transition-colors">
        <div className="flex items-start justify-between">
          <div className="label-caps text-[10px] leading-tight">Raw materials waiting for QC</div>
          <ShieldCheck size={13} strokeWidth={1.75} className="text-neutral-400 shrink-0" />
        </div>
        <div className="font-mono-num text-lg md:text-xl font-bold mt-1.5 tracking-tight text-neutral-900">{total == null ? "—" : n(total)}</div>
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl rounded-sm max-h-[85vh] overflow-y-auto" data-testid="materials-qc-dialog">
          <DialogHeader>
            <DialogTitle className="font-display">Raw materials waiting for QC</DialogTitle>
          </DialogHeader>
          <QcMaterials />
        </DialogContent>
      </Dialog>
    </>
  );
}
